import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import SettingsMyotbSummaryBasket from 'lumen/components/settings/myotb/summary-basket';
import SettingsPageTemplate from 'lumen/components/settings/page-template';
import type HotelSettingsMyotbController from 'lumen/controllers/hotel/settings/myotb';

interface HotelSettingsMyotbSignature {
  Args: {
    controller: HotelSettingsMyotbController;
    model: unknown;
  };
}

<template>
  <SettingsPageTemplate
    @description={{t "settings.my_otb.description"}}
    @hasAccountSelector={{true}}
    @title={{t "settings.my_otb.setup"}}
    @type="container"
  >
    <:default>
      <div class="flex justify-center gap-400">
        <div class="myotb-page w-full overflow-hidden">
          <div class="flex flex-col">
            {{outlet}}
          </div>
        </div>

        {{#if @controller.showSummaryBasket}}
          <div>
            <SettingsMyotbSummaryBasket />
          </div>
        {{/if}}
      </div>
    </:default>
  </SettingsPageTemplate>
</template> satisfies TOC<HotelSettingsMyotbSignature>;
